import { combineReducers } from 'redux';

// reducer import
import customizationReducer from './customizationReducer';
import CartReducer from './CartReducer';
import CartPreorderReducer from './CartPreorderReducer';
import CartCustomerReducer from './CartCustomerReducer';
// ==============================|| COMBINE REDUCER ||============================== //

const reducer = combineReducers({
    customization: customizationReducer,
    cart: CartReducer,
    cartPreorder: CartPreorderReducer,
    cartCustomer: CartCustomerReducer
});

export default reducer;
